import { useRowCountdown } from "./timer";

export function RowTimer({ createdAt }) {
  const { label, isExpired } = useRowCountdown(createdAt, 15 * 60 * 1000);

  return (
    <span
      className={`text-xs font-semibold ${
        isExpired ? "text-slate-400" : "text-amber-600"
      }`}
    >
      {label}
    </span>
  );
}
